/*
 * Copyright (c) Dito Technologies LLC
 */

import {State, StepStatus} from "ui/feature/root/FormReducer";

export default function UsePlayAvailable(state: State): boolean {
    if (state.uploadStepStatus !== StepStatus.SUCCESS || state.noteFinderUserConfirmationStatus !== StepStatus.SUCCESS || state.noteFinderUserConfirmationStatus !== StepStatus.SUCCESS) {
        return false;
    } else {
        return true;
    }
}
